export class Content {
    constructor(public type: string, public body: any) {
    }
}
